var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.openid == 0)?_c('span',[_vm._v("暂无")]):_c('ww-open-data',{attrs:{"type":_vm.type,"openid":_vm.openid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }